import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class MemberByInvitation {

  constructor(private http: HttpClient) { }

  public addAndInviteMember(payload): Observable<any> {
    payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
    if (payload.rgaRoleViewDtoList[0].panelId) {
      payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId
      delete payload.rgaRoleViewDtoList[0].panelId
    }
    if (!payload.disciplinaryPanelId) {
      delete payload.rgaRoleViewDtoList[0].panelId
    }
    
    try {
      return this.http.post(environment.BASE_URL_HRD + "tmMng/inviteUser"
        , payload)
    }
    catch (exception) {
      console.log(exception)
    }
  }

  public addAndInviteMemberAdministrative(payload): Observable<any> {
    payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
    try {
      return this.http.post(environment.BASE_URL_HRD + "tmMng/inviteAdministrativeUser"
        , payload)
    }
    catch (exception) {
      console.log(exception)
    }
  }

}
